module.exports = __webpack_public_path__ + "img/orangeLine.d7475dac.svg";